"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestTestResults = exports.TestTestingFailedTasks = exports.TestTestingCompletedTasks = exports.TestTestingResult = exports.TestTestingSettings = exports.SelectionStrategy = void 0;
const jeed_types_1 = require("@cs124/jeed-types");
const runtypes_1 = require("runtypes");
const languages_1 = require("./languages");
const steps_1 = require("./steps");
exports.SelectionStrategy = (0, runtypes_1.Union)((0, runtypes_1.Literal)("HARDEST"), (0, runtypes_1.Literal)("EASIEST"), (0, runtypes_1.Literal)("EVENLY_SPACED"), (0, runtypes_1.Literal)("EASIEST_AND_HARDEST"));
exports.TestTestingSettings = (0, runtypes_1.Partial)({
    shortCircuit: runtypes_1.Boolean,
    limit: runtypes_1.Number,
    SelectionStrategy: exports.SelectionStrategy,
    seed: runtypes_1.Number,
});
exports.TestTestingResult = (0, runtypes_1.Record)({
    correct: runtypes_1.Number,
    incorrect: runtypes_1.Number,
    total: runtypes_1.Number,
    duration: runtypes_1.Number,
    succeeded: runtypes_1.Boolean,
    shortCircuited: runtypes_1.Boolean,
    output: (0, runtypes_1.Array)(runtypes_1.String),
}).And((0, runtypes_1.Partial)({
    selectionStrategy: exports.SelectionStrategy,
    identifiedSolution: runtypes_1.Boolean,
    correctMap: (0, runtypes_1.Dictionary)(runtypes_1.Boolean, runtypes_1.Number),
}));
exports.TestTestingCompletedTasks = (0, runtypes_1.Partial)({
    // templateSubmission doesn't complete
    compileSubmission: jeed_types_1.CompiledSourceResult,
    checkstyle: jeed_types_1.CheckstyleResults,
    ktlint: jeed_types_1.KtlintResults,
    // checkCompiledSubmission doesn't complete
    testTesting: exports.TestTestingResult,
});
exports.TestTestingFailedTasks = (0, runtypes_1.Partial)({
    checkInitialSubmission: runtypes_1.String,
    templateSubmission: jeed_types_1.TemplatingFailed,
    compileSubmission: jeed_types_1.CompilationFailed,
    checkstyle: jeed_types_1.CheckstyleFailed,
    ktlint: jeed_types_1.KtlintFailed,
    checkCompiledSubmission: runtypes_1.String,
    checkExecutedSubmission: runtypes_1.String,
});
exports.TestTestResults = (0, runtypes_1.Record)({
    language: languages_1.Languages,
    completedSteps: (0, runtypes_1.Array)(steps_1.TestTestingStep),
    complete: exports.TestTestingCompletedTasks,
    failedSteps: (0, runtypes_1.Array)(steps_1.TestTestingStep),
    failed: exports.TestTestingFailedTasks,
    skippedSteps: (0, runtypes_1.Array)(steps_1.TestTestingStep),
    timeout: runtypes_1.Boolean,
    lineCountTimeout: runtypes_1.Boolean,
    completed: runtypes_1.Boolean,
    succeeded: runtypes_1.Boolean,
}).And((0, runtypes_1.Partial)({
    kind: (0, runtypes_1.Literal)("TESTTESTING"),
    failedLinting: runtypes_1.Boolean,
}));
//# sourceMappingURL=testtesting.js.map